import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TextArea } from "@progress/kendo-react-inputs";
import Body from "commons/card/Body";
import CollapsableCard from "commons/card/CollapsableCard";
import { LabelInfo } from "commons/forms/LabelInfo";
import MinContentCustomModal from "commons/modal/MinContentCustomModal";
import * as r from "constants/routes";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "scss/_projectDetail.scss";
import { getSearchParams } from "../../../commons/models/params";
import { padZerosLeft } from "commons/helpers/StringHelper";
import { PTR_LENGTH } from "constants/products";

export default function ProductDetail(props) {
  const [order, setOrder] = useState(
    props.order !== undefined ? props.order : "ptr"
  );
  const location = useLocation();

  const queryUpdate = (action) => {
    let query = `&ptr=${getSearchParams("Produit", location.pathname)}&`;
    return `ordre=${order}${query}${action}`;
  };

  const onNavigate = async (e) => {
    let queryparams = `${
      e === -1
        ? queryUpdate(r.INV_PREFIX_QUERY_BEFORE)
        : queryUpdate(r.INV_PREFIX_QUERY_NEXT)
    }`;
    props.update(queryparams, order);
  };

  return (
    <div>
      <div
        style={{
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
          margin: "50px 15px 0 15px",
        }}
      >
        <div
          className="inline"
          style={{
            backgroundColor: "white",
            border: "1px #f3f5f5 solid",
            borderBottom: "0px white solid",
            borderRadius: "1px",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
            padding: "15px 30px 15px 30px",
            marginTop: "15px",
          }}
        >
          <h1
            style={{
              textTransform: "uppercase",
              color: "dimgrey",
              fontWeight: "bold",
              fontSize: "22px",
            }}
            className="me-auto"
          >
            {props.data.mod_descr}
          </h1>
        </div>
        <CollapsableCard
          type="none"
          canCollapse={false}
          style={{
            margin: "0",
            marginBottom: "20px",
          }}
        >
          <Body>
            <div
              className="inline"
              style={{
                margin: "15px 0 20px 0",
              }}
            >
              <div className="me-auto">
                <Button
                  style={{
                    margin: "2px",
                    marginRight: "15px",
                  }}
                  className="whiteButton"
                  onClick={() => {
                    onNavigate(-1);
                  }}
                >
                  Précédent
                </Button>
                <Button
                  style={{
                    margin: "2px",
                    marginRight: "15px",
                  }}
                  className="whiteButton"
                  onClick={() => {
                    onNavigate(+1);
                  }}
                >
                  Suivant
                </Button>
                <DropDownList
                  className="whiteButton"
                  onChange={(e) => setOrder(e.value)}
                  style={{
                    margin: "2px",
                    marginRight: "15px",
                  }}
                  data={["ptr", "four", "cat", "coll"]}
                  defaultValue={order}
                />
                <div
                  style={{
                    display: "inline-flex",
                    margin: "2px",
                    marginRight: "15px",
                  }}
                >
                  <div
                    style={{
                      marginRight: "15px",
                    }}
                  >
                    <MinContentCustomModal
                      text={"Voir les notes"}
                      title={"Note"}
                    >
                      <TextArea
                        style={{ width: "100%" }}
                        rows={4}
                        value={props.data.comment}
                      />
                    </MinContentCustomModal>
                  </div>

                  <div>
                    <MinContentCustomModal
                      text={"Voir les fichiers"}
                      title={"Fichier"}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "20px",
                        }}
                      >
                        {props.data.doc?.map((x) => {
                          if (x.typeDoc === "Photo")
                            return (
                              <img
                                alt="img"
                                key={x.nom}
                                style={{ width: "12rem", objectFit: "contain" }}
                                src={`https://api.tanguayelectronique.ca/${x.chemin.replace(
                                  "imgptr",
                                  "ImgPtr"
                                )}${x.nom}`}
                              />
                            );
                          else if (x.typeDoc === "Video")
                            return (
                              <video controls key={x.nom}>
                                <source
                                  src={`https://api.tanguayelectronique.ca/${x.chemin.replace(
                                    "imgptr",
                                    "ImgPtr"
                                  )}${x.nom}`}
                                />
                              </video>
                            );
                          else if (x.typeDoc === "Pdf")
                            return (
                              <span
                                style={{
                                  backgroundColor: "transparent",
                                  cursor: "pointer",
                                  color: "black",
                                }}
                                key={x.nom}
                                className="k-icon k-font-icon k-i-pdf k-icon-xxxl"
                                onClick={() =>
                                  window.open(
                                    `https://api.tanguayelectronique.ca/${x.chemin.replace(
                                      "imgptr",
                                      "ImgPtr"
                                    )}${x.nom}`,
                                    "_blank"
                                  )
                                }
                              />
                            );
                        })}
                      </div>
                    </MinContentCustomModal>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <LabelInfo
                col={1}
                label="Ptr"
                value={padZerosLeft(props.data.prod_num, PTR_LENGTH)}
                style={{ color: "#636060" }}
              />
              <LabelInfo
                label="Fournisseur"
                col={2}
                value={`${props.data.four_cd}-${props.data.four_nom}`}
              />
              <LabelInfo
                label="Modèle"
                col={2}
                value={`${props.data.mod_cd} - ${props.data.mod_descr}`}
              />
              <LabelInfo label="Catégorie" value={props.data.cat_cd} />

              {props.data.reg === null ? (
                <LabelInfo
                  label="Prix régulier"
                  value={`${props.data.prix} $`}
                />
              ) : (
                <LabelInfo
                  label="Prix régulier"
                  value={`${props.data.reg} $`}
                />
              )}

              {props.data.reg === null ? (
                <></>
              ) : (
                <LabelInfo
                  label="Prix spécial"
                  value={`${props.data.prix} $`}
                />
              )}

              <LabelInfo
                label="Coût"
                value={props.data.cout !== null ? `${props.data.cout} $` : " "}
              />
              <LabelInfo
                col={1}
                label="Code activité"
                value={props.data.act_descr}
                style={{ color: "#636060" }}
              />
              <LabelInfo
                label="Fini"
                col={2}
                value={props.data.fini_cd}
                values={props.data.fini_multi.split("þ")}
              />
            </div>
          </Body>
        </CollapsableCard>
      </div>
    </div>
  );
}
ProductDetail.propTypes = {
  data: PropTypes.shape({
    act_descr: PropTypes.string,
    ann_note: PropTypes.any,
    ann_num: PropTypes.any,
    cat_cd: PropTypes.any,
    comment: PropTypes.any,
    cout: PropTypes.any,
    doc: PropTypes.array,
    fini_cd: PropTypes.any,
    fini_multi: PropTypes.string,
    four_cd: PropTypes.string,
    four_nom: PropTypes.string,
    mod_cd: PropTypes.string,
    mod_descr: PropTypes.any,
    prix: PropTypes.number,
    prod_num: PropTypes.any,
    reg: PropTypes.any,
  }),
  update: PropTypes.func,
  order: PropTypes.string,
};
